import React from "react";
import Body from "theme/components/atoms/Typography/Body";
import Price from "theme/components/atoms/Typography/Price";
import Percent from "theme/components/atoms/Typography/Percent";

const getExtraCostValue = (extraCost) => {
  if (!extraCost) {
    return null;
  }
  if (extraCost.rate) {
    return extraCost.rate;
  }
  if (extraCost.prices && extraCost.prices.priceInclTax.value.amount) {
    return extraCost.prices.priceInclTax;
  }
  return null;
};

const CustomOptionLabelWithPrice = ({ option }) => {
  const extraCost = option.extraCost;
  const extraCostValue = getExtraCostValue(extraCost);
  if (!extraCostValue) {
    return <Body>{option.title}</Body>;
  }
  return (
    <Body>
      {option.title + " (+"}
      {extraCost.type === "percent" ? (
        <Percent value={extraCostValue / 100} />
      ) : (
        <Price price={extraCostValue} />
      )}
      )
    </Body>
  );
};

export default CustomOptionLabelWithPrice;
